import React from 'react';

export const SubscriptionForm = props => {
  const {formData, handleFormChange, handleValidation100, handleValidation1000, isCCValid} = props;

  return (
    <div>
      <div className="form-group mt-1 d-flex justify-content-between">
        <div className="form-group mt-1 p-1">
          <label>First Name</label>
          <input
            value={formData?.firstname}
            onChange={handleFormChange}
            name="firstname"
            id="firstname"
            type="text"
            className="form-control mt-1"
          />
        </div>
        <div className="form-group mt-1 p-1">
          <label>Last Name</label>
          <input
            value={formData?.lastname}
            onChange={handleFormChange}
            name="lastname"
            id="lastname"
            type="text"
            className="form-control mt-1"
          />
        </div>
      </div>
      <div className="form-group mt-1">
        <label>Credit Card Number</label>
        <input
          value={formData?.cc}
          onChange={handleFormChange}
          name="cc"
          id="cc"
          type="number"
          className={
            isCCValid ? 'form-control mt-1 input-sm' : 'form-control mt-1 input-sm is-invalid'
          }
          minLength={16}
        />
        <div className="invalid-feedback">Invalid Card Number</div>
      </div>
      <div className="form-group mt-1 d-flex justify-content-between">
        <div className="form-group mt-1 p-1">
          <label>Expiry</label>
          <div className="form-group d-inline-flex">
            <input
              value={formData?.expiryMM}
              onChange={handleValidation100}
              name="expiryMM"
              id="expiryMM"
              type="number"
              className="form-control mt-1"
              placeholder="MM"
              min={1}
              max={12}
            />
            <input
              value={formData?.expiryYY}
              onChange={handleValidation100}
              name="expiryYY"
              id="expiryYY"
              type="number"
              className="form-control mt-1"
              placeholder="YY"
              min={22}
              max={99}
            />
          </div>
        </div>
        <div className="form-group mt-1 p-1">
          <label>CVV</label>
          <input
            value={formData?.cvv}
            onChange={handleValidation1000}
            name="cvv"
            id="cvv"
            type="number"
            className="form-control mt-1"
            placeholder="XXX"
            min={100}
            max={999}
          />
        </div>
      </div>
      <div className="form-group mt-1">
        <label>Billing Address 1</label>
        <input
          value={formData?.address1}
          onChange={handleFormChange}
          name="address1"
          id="address1"
          type="text"
          className="form-control mt-1"
        />
      </div>
      <div className="form-group mt-1">
        <label>Billing Address 2</label>
        <input
          value={formData?.address2}
          onChange={handleFormChange}
          name="address2"
          id="address2"
          type="text"
          className="form-control mt-1"
        />
      </div>
      <div className="form-group mt-1">
        <label>City</label>
        <input
          value={formData?.city}
          onChange={handleFormChange}
          name="city"
          id="city"
          type="text"
          className="form-control mt-1"
        />
      </div>
      <div className="form-group mt-1">
        <label>Country</label>
        <input
          value={formData?.country}
          onChange={handleFormChange}
          name="country"
          id="country"
          type="text"
          className="form-control mt-1"
        />
      </div>
      <div className="form-group mt-1 d-flex justify-content-between">
        <div className="form-group p-1">
          <label>Zip Code</label>
          <input
            value={formData?.zip}
            onChange={handleFormChange}
            name="zip"
            id="zip"
            type="text"
            className="form-control mt-1"
            maxLength={6}
          />
        </div>
        <div className="form-group p-1">
          <label>State</label>
          <input
            value={formData?.state}
            onChange={handleFormChange}
            name="state"
            id="state"
            type="text"
            className="form-control mt-1"
          />
        </div>
      </div>
    </div>
  );
};
